/**
 * Created by Oles on 4/27/2017.
 */
import client from '@common/utils/rest.js'

import { PatientActions, TestActions, ResultsTableActions } from '../const/ActionsConst';
import { MessageBoxTypes, OTHER_LAB_OPTION_NAME } from '../const/TestResultsConst';
import { getPanelsFlat } from './panels';

export const getPatientTestResults = () => (dispatch,getState) => {
    const patientId = getState().patient.id;
    client({
        path: 'api/testsResults/get/' + patientId,
        headers: {'Pragma': 'no-cache'}
    })
        .then(
            response => {
                if (response.status.code == 200) {
                    dispatch(setTestResults(response.entity))
                } else {
                    dispatch(showMessageBox(true, MessageBoxTypes.ERROR, 'small', response.entity))
                }
            },
            error => {
                console.log('getTestResults: ', error);
                dispatch(showMessageBox(true, MessageBoxTypes.ERROR, 'small', error))}
        )
        .then(
            () => {
                client({
                    path: 'api/testsResults/ambryStatus',
                    headers: {'Pragma': 'no-cache'}
                })
                    .then(
                        response => {dispatch(setAmbryStatus(response.entity.toString()))},
                        error => {console.log('getAmbryStatus: ', error)}
                    );
            }
        )
};

const setTestResults = tests => ({
    type: PatientActions.SET_TEST_RESULTS,
    tests: tests
});

const displayTestDetails = (show, id) => ({
    type: PatientActions.SHOW_TEST_DETAILS,
    id: id,
    show: show
});

export const getLabs = () => {
    return client({
        path: 'api/testsResults/labs',
        headers: {'Pragma': 'no-cache'}
    }).then((res) => res.entity);
};

export const showTestDetails = (show, id) => async (dispatch, getState) => {
    if (show) {

        dispatch(displayTestDetails(show, id));

        const customPanelsFormats = await getPanelsFlat();
        const panelsByLabName = customPanelsFormats.reduce((acc, panel) => {
            const labName = panel.lab === OTHER_LAB_OPTION_NAME ? panel.otherlab : panel.lab;

            if (!acc[labName]) {
                acc[labName] = [];
            }

            acc[labName].push(panel);

            return acc;
        }, {});

        client({
            path: 'api/testsResults/labs',
            headers: {'Pragma': 'no-cache'}
        })
            .then(
                response => {
                    const otherLabsFromCustomPanels = [
                        ...new Set(customPanelsFormats
                            .filter((x) => x.lab === OTHER_LAB_OPTION_NAME)
                            .map((panel) => ({ name: panel.otherlab, tests: [] }))
                            .sort((a, b) => a.name.localeCompare(b.name))
                        )
                    ];
                    

                    const processedEntity = [...response.entity, ...otherLabsFromCustomPanels].map((lab) => {
                        const testsFromCustomPanelsWithSameLab = (panelsByLabName[lab.name] || [])
                            .map((panel) => {
                                return {
                                    name: panel.customname,
                                    genes: panel.genes.map((x) => ({
                                        name: x.gene,
                                        variant: x.variant,
                                        classification: x.classification,
                                        priorClassification: x.priorclassification,
                                    })),
                                };
                            })
                            .sort((a, b) => a.name.localeCompare(b.name));


                        lab.tests = lab.tests.concat(testsFromCustomPanelsWithSameLab);

                        return lab;
                    });

                    dispatch(setLabs(processedEntity))
                },
                error => {console.log('getLabs: ', error)}
            )
            .then(
                () => {
                    client({
                        path: 'api/testsResults/genes',
                        headers: {'Pragma': 'no-cache'}
                    })
                        .then(
                            response => {dispatch(setGenes(response.entity))},
                            error => {console.log('getGenes: ', error)}
                        )
                        .then(
                            () => {dispatch(setCurrentTestId(id))}
                        )
                        .then(
                            () => {dispatch(displayTestDetails(show, id))}
                        )
                }
            )
    } else {
        dispatch(displayTestDetails(show, id));
    }
};

const setLabs = labs => ({
    type: PatientActions.SET_LABS,
    labs: labs
});

const setGenes = genes => ({
    genes,
    type: PatientActions.SET_GENES,
});

export const getAndSetGenes = () => (dispatch) => {
    return client({
        path: 'api/testsResults/genes',
    }).then((response) => {
        dispatch(setGenes(response.entity));
    });
};

export const resetGenes = () => (dispatch) => {
    dispatch({
        type: TestActions.RESET_GENES,
    });
};

export const saveTestDetails = () => (dispatch, getState) => {
    dispatch(setTestDetailsSaving(true));
    const test = { ...getState().testDetails.test };
    test.globalId = getState().patient.id;
    test.ambryId = test.ambryId ? test.ambryId : 0;
    test.orderid = test.orderid ? test.orderid : 0;
    test.globalId = test.globalId ? test.globalId : 0;
    test.genes = (test.genes || []).map((x) => ({
        id: x.notSaved ? null : x.id,
        gene: x.gene,
        variant: x.variant,
        classification: x.classification,
        priorClassification: x.priorClassification,
        external: x.external,
        rowNumber: x.rowNumber,
    }));

    client({
        path: 'api/testsResults/',
        method: 'POST',
        entity: test})
        .then(
            (response) => {
                var files = getState().testDetails.files;
                dispatch(sendFiles(test.id ? test.id : response.entity, files))
            },
            error => {console.log('saveTestDetails: ', error); dispatch(setTestDetailsSaving(false));}
        )
        .then(() => {
            if (getState().testDetails.toDelete) {
                dispatch(bulkDeleteDocs(getState().testDetails.toDelete));
            }
        })
};

const bulkDeleteDocs = docs => dispatch => {
    var ids = docs.map(id => {return 'ids=' + id}).join('&');
    client({
        path: 'api/testsResults/documents/delete?' + ids,
        method: 'POST'})
    .then(
        () => {
            dispatch(getPatientTestResults());
            dispatch(setCurrentDoc(undefined));
        },
        error => {
            console.log('deleteDocs: ', error);
        }
    )
};

const setTestDetailsSaving = isSaveInProgress => ({
    type: PatientActions.SET_TEST_DETAILS_SAVING,
    saving: isSaveInProgress
});

export const showMessageBox = (show, type, size = 'small', text) => ({
    type: PatientActions.SHOW_MESSAGE_BOX,
    messageBox: {
        type: type,
        show: show,
        size: size,
        text: text
    }
});

export const messageBoxConfirmed = type => {
    return (dispatch,getState) => {
        switch (type) {
            case MessageBoxTypes.DELETE_TEST:
                var id = getState().currentTestId;
                dispatch(deleteTest(id));
                break;
            case MessageBoxTypes.DELETE_DOC:
                dispatch(showMessageBox(false));
                var doc = getState().currentDoc;
                dispatch(deleteDoc(doc));
                break;
            case MessageBoxTypes.MULTIPLE_REPORTS:
                var id = getState().currentTestId;
                dispatch(resetPotentialFamilyMemberReportsFlag(id));
                break;
            default:
                dispatch(showMessageBox(false));
                break;
        }
    }
};

export const setCurrentTestId = id => ({
    type: PatientActions.SET_CURRENT_TEST,
    id: id
});

export const resetPotentialFamilyMemberReportsFlag = id => dispatch => {
    client(
        {
            path: 'api/testsResults/' + id + '/resetFlag',
            method: 'POST',
            headers: {'Content-Type': 'application/json'}
        }
    )
        .then(
            () => {
                dispatch(resetMultipleReportsFlag(id));
                dispatch(showMessageBox(false));
            },
            error => {console.log('resetPotentialFamilyMemberReportsFlag: ', error)}
        )
};

const resetMultipleReportsFlag = id => ({
    type: TestActions.RESET_MULTIPLE_REPORTS_FLAG,
    id: id
});

export const deleteTest = id => dispatch => {
    client(
        {
            path: 'api/testsResults/' + id + '/delete',
            method: 'POST',
            headers: {'Content-Type': 'application/json'}
        }
    )
    .then(
        () => {
            dispatch(showMessageBox(false));
            dispatch(removeTest(id));
        },
        error => {console.log('deleteTestResult: ', error)}
    )
};

const removeTest = id => ({
    type: TestActions.REMOVE_TEST,
    id: id
});

export const addGenesTableRow = () => ({
    type: TestActions.ADD_GENES_TABLE_ROW
});

export const deleteGenesTableRow = () => ({
    type: TestActions.DELETE_GENES_TABLE_ROW
});

export const updateInitialGenes = (genes) => ({
    type: TestActions.UPDATE_INITIAL_GENES,
    genes
});

export const updateTestDetails = (fieldId, value) => ({
    type: TestActions.UPDATE_TEST_DETAILS,
    fieldId: fieldId,
    value: value
});

export const selectAllGenes = checked => ({
    type: TestActions.SELECT_ALL_GENES,
    checked: checked
});

export const checkGene = (id,checked) => ({
    type: TestActions.SELECT_GENE,
    gene: {
        id: id,
        checked: checked
    }
});

export const updateGenesTableRow = (geneId, fieldId, value) => ({
    type: TestActions.UPDATE_GENES_TABLE_ROW,
    gene: {
        id: geneId,
        fieldId: fieldId,
        value: value
    }
});

export const populateTestsForSelectedLab = lab => ({
    type: TestActions.SELECT_LAB,
    lab: lab
});

export const populateGenesForSelectedTest = testOrdered => ({
    type: TestActions.SELECT_TEST_ORDERED,
    testOrdered: testOrdered
});

export const setTestStatus = status => ({
    type: TestActions.SELECT_TEST_STATUS,
    status: status
});

export const setFieldValidationResult = (fieldId, error) => ({
    type: TestActions.SET_VALIDATION_RESULT,
    fieldId: fieldId,
    error: error
});

export const uploadDocs = files => ({
    type: TestActions.UPLOAD_DOCS,
    files: files
});

export const unloadDoc = fileName => ({
    type: TestActions.UNLOAD_DOC,
    name: fileName
});

export const sendFiles = (testId, files) => dispatch => {
    if (files && files.length > 0) {
        var form = new FormData();
        for (var i = 0; i < files.length; i++) form.append('file', files[i]);
        client({
            path: 'api/testsResults/' + testId + '/documents',
            method: 'POST',
            headers: {'Content-Type': 'multipart/form-data'},
            entity: form})
            .then(
                () => {dispatch(getPatientTestResults())},
                error => {
                    console.log('sendFiles: ', error);
                    dispatch(setTestDetailsSaving(false));
                }
            ).then(
                () => {
                    dispatch(showTestDetails(false));
                    dispatch(setTestDetailsSaving(false));
                }
            );
    } else {
        dispatch(getPatientTestResults());
        dispatch(showTestDetails(false));
        dispatch(setTestDetailsSaving(false));
    }
};

export const setDefaultColumnsWidth = clientWidth => ({
    type: ResultsTableActions.SET_DEFAULT_WIDTH,
    width: clientWidth
});

export const columnResized = (newColumnWidth, columnKey) => ({
    type: ResultsTableActions.RESIZE_COLUMN,
    columnsObject: {
        newColumnWidth: newColumnWidth,
        columnKey: columnKey
    }
});

export const loadColumnsWidth = () => dispatch => {
    client({
        path: 'api/testsResults/columnsWidth',
        headers: {'Pragma': 'no-cache'}
    })
        .then(
            response => {dispatch(setColumnsWidth(response.entity))},
            error => {console.log('loadColumnsWidth: ', error);}
        ).then(
            () => {
                dispatch(setDefaultColumnsWidth(window.innerWidth - 15));
            }
        );
};

export const setColumnsWidth = columnsWidth => ({
    type: PatientActions.SET_COLUMNS_WIDTH,
    columnsWidth: columnsWidth
});

export const saveColumnWidth = (columnWidth, columnKey) => dispatch => {
    const width = {
        "column" : columnKey,
        "width" : columnWidth
    };
    client({
        path: 'api/testsResults/saveColumnWidth',
        method: 'POST',
        entity: width
    })
    .then(
        () => {dispatch(columnResized(columnWidth, columnKey))},
        error => {console.log('saveColumnWidth: ', error);}
    );
};

export const openDocument = docId => dispatch => {
    window.open('api/testsResults/documents/' + docId);
    return {
        type: TestActions.GET_DOC
    }
};

export const openDocumentByUrl = url => dispatch => {
    window.open(url);
    return {
        type: TestActions.GET_DOC
    }
};

export const deleteDocument = (docId, docName, doDelete) => dispatch => {
    dispatch(setCurrentDoc(docId, docName, doDelete));
    dispatch(showMessageBox(true, MessageBoxTypes.DELETE_DOC, 'sm'));
};

const setCurrentDoc = (id, name, doDelete) => ({
    type: TestActions.SET_CURRENT_DOC,
    id: id,
    name: name,
    doDelete: doDelete
});

const deleteDoc = doc => dispatch => {
    if (doc.id == undefined) {
        dispatch(unloadDoc(doc.name));
    } else if (doc.doDelete) {
        client(
            {
                path: 'api/testsResults/documents/' + doc.id + '/delete',
                method: 'POST',
                headers: {'Content-Type': 'application/json'}
            }
        )
        .then(
            () => {
                dispatch(setCurrentDoc(undefined));
                dispatch(getPatientTestResults())
            },
            error => {
                console.log('deleteDoc: ', error);
            }
        )
        .then(
            () => {dispatch(removeDoc(doc.id))},
            error => {console.log('deleteDocument: ', error)}
        )
    } else {
        dispatch(setDocToDelete(doc.id))
    }
};

const removeDoc = id => ({
    type: TestActions.DELETE_DOC,
    id: id
});

const setDocToDelete = id => ({
    type: TestActions.SET_DOC_TO_DELETE,
    id: id
});

export const setAmbryStatus = status => ({
    type: PatientActions.SET_AMBRY_STATUS,
    status: status
});

export const loginToAmbry  = () => (dispatch, getState) => {
    client({
        path: 'ambry/orders/login-first',
        method: 'POST'})
        .then(
            () => {
                getPatientTestResults()(dispatch, getState);
                console.log('logged in to ambry');
            },
            error => {
                getPatientTestResults()(dispatch, getState);
                console.log('loginToAmbry: ', error);
            }
        )
};

export const setBlacklistFileExtensions = (payload) => ({
    type: TestActions.SET_BLACKLIST_FILE_EXTENSIONS,
    payload
});

export const loadBlacklistFileExtensions = () => (dispatch) => {
    client({
        path: 'api/testsResults/documents/blacklist',
        method: 'GET'
    })
    .then((response) => {
        const extensions = (response.entity || []).map((extension) => extension.replace('*.', ''));
        dispatch(setBlacklistFileExtensions(extensions));
    })
}